import React from "react";
import { Autoplay, FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { useIsMobile } from "../../device/selectors";

import "swiper/css";
import { DAILY_PRIZES } from "../renders/christmas-raffle/AllPrizesModal/utils/dailyPrizes";
import { FINAL_PRIZES } from "../renders/christmas-raffle/AllPrizesModal/utils/finalPrizes";
//import "swiper/css/navigation";

const InstantPrizes = () => {
  const isMobile = useIsMobile();
  const pastInstantWins = DAILY_PRIZES.map(prize => {
    if (prize.imgId !== "keyboxes") {
      return prize;
    }
    const finaleCount = FINAL_PRIZES.find(item => item.imgId === "keyboxes")?.count ?? "0";
    const total = [prize.count, finaleCount].reduce((sum, count) => sum + Number(String(count).replace(/,/g, "")), 0);
    return { ...prize, count: total.toLocaleString("en-GB") };
  });
  const [firstHalf, secondHalf] = [
    pastInstantWins.slice(0, pastInstantWins.length / 2),
    pastInstantWins.slice(pastInstantWins.length / 2),
  ];

  const isDailyPrize = (imgId: string) => {
    return DAILY_PRIZES.find(p => p.imgId === imgId) !== undefined;
  };

  const slideKlass =
    "h-[72px] lg:h-[96px] bg-white shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)] rounded-lg py-2 pr-2 pl-3 relative overflow-hidden flex justify-between gap-2";

  return (
    <div className={"pt-8 lg:pt-10 mb-10 lg:mb-16 font-jost bg-gray-4"}>
      <div className={"flex-center flex-col text-center mb-6 lg:mb-8"}>
        <div
          className={
            "uppercase text-center text-dark-1 font-bold text-lg leading-6 lg:text-2xl lg:leading-7.5 mb-3 lg:mb-4"
          }>
          36,000 PRIZES AWAIT
          {/* 75,000 PRIZES AWAIT */}
        </div>
        <div className={"mx-auto font-normal text-gray-1 leading-5 lg:leading-6 text-sm lg:text-lg"}>
          Each ticket brings you closer to winning.
        </div>
      </div>

      <div>
        <div className={"lg:mb-3 relative"}>
          <Swiper
            modules={[Autoplay, FreeMode]}
            breakpoints={{
              0: { slidesPerView: 1.69 },
              480: { slidesPerView: 2.2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 3.5 },
              1200: { slidesPerView: 4, spaceBetween: 20 },
              1400: { slidesPerView: 5, spaceBetween: 20 },
              1600: { slidesPerView: 6.8 },
            }}
            loop={true}
            initialSlide={isMobile ? 2 : 1}
            slidesOffsetBefore={isMobile ? -50 : -30}
            centeredSlides={isMobile}
            spaceBetween={isMobile ? 16 : 20}
            freeMode={true}
            speed={8000}
            allowTouchMove={false}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            className="marquee-swiper pointer-events-none !py-1.5">
            {(isMobile ? firstHalf : pastInstantWins).map((data, index) => {
              // const prizeName = data.name && data.name.includes()
              return (
                <SwiperSlide key={index}>
                  <div className={slideKlass}>
                    <div className={"flex flex-col justify-center gap-0.5 relative z-[1] w-full max-w-[50%]"}>
                      <div className={"text-base lg:text-xl font-bold leading-5.5 lg:leading-6.5"}>
                        <span
                          className={
                            "bg-gradient-botb bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] "
                          }>
                          {data.count}x
                        </span>
                      </div>
                      <div className={"text-xs font-medium lg:text-base lg:leading-[22px] flex flex-col text-gray-1"}>
                        <span>{data.prize}</span>
                      </div>
                    </div>
                    <img
                      src={`/assets/images/christmas-raffle/${isDailyPrize(data.imgId) ? "daily-prizes" : "final-prizes"}/${data.imgId}.png`}
                      alt={"prize"}
                      width={isMobile ? 85 : 120}
                      height={isMobile ? 56 : 80}
                      className={"self-center absolute right-2 inset-y-0 shrink-0"}
                    />
                    <div className="size-40 -left-20 -top-[90px] lg:-top-[100px] absolute bg-[#EDF1FF] rounded-full blur-[80px] z-0" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className={"relative"}>
          <Swiper
            modules={[Autoplay, FreeMode]}
            breakpoints={{
              0: { slidesPerView: 1.69 },
              480: { slidesPerView: 2.2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 3.5 },
              1200: { slidesPerView: 4, spaceBetween: 20 },
              1400: { slidesPerView: 5, spaceBetween: 20 },
              1600: { slidesPerView: 6.8 },
            }}
            loop={true}
            centeredSlides={isMobile}
            spaceBetween={isMobile ? 16 : 20}
            slidesOffsetBefore={isMobile ? 50 : 52}
            initialSlide={2}
            freeMode={true}
            speed={8000}
            allowTouchMove={false}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              reverseDirection: true,
            }}
            className="marquee-swiper-2 pointer-events-none !py-1.5">
            {(isMobile ? secondHalf : pastInstantWins).map((data, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className={slideKlass}>
                    <div className={"flex flex-col justify-center gap-0.5 relative z-[1] w-full max-w-[50%]"}>
                      <div className={"text-base lg:text-xl font-bold leading-5.5 lg:leading-6.5"}>
                        <span
                          className={
                            "bg-gradient-botb bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] "
                          }>
                          {data.count}x
                        </span>
                      </div>
                      <div
                        className={
                          "text-xs font-medium lg:text-base lg:leading-[22px] flex flex-col gap-0.5 text-gray-1"
                        }>
                        <span>{data.prize}</span>
                      </div>
                    </div>

                    <img
                      src={`/assets/images/christmas-raffle/${isDailyPrize(data.imgId) ? "daily-prizes" : "final-prizes"}/${data.imgId}.png`}
                      alt={"prize"}
                      width={isMobile ? 85 : 120}
                      height={isMobile ? 56 : 80}
                      className={"self-center absolute right-2 inset-y-0 shrink-0"}
                    />
                    <div className="size-40 -left-20 -top-[90px] lg:-top-[100px] absolute bg-[#EDF1FF] rounded-full blur-[80px] z-0" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>

      {/*<div className={"w-full flex-center mt-6 lg:mt-10"}>*/}
      {/*    <button*/}
      {/*        className="btn btn-sm-2 lg:btn-lg btn-white-outline min-w-[212px] gap-1.5 lg:gap-2 lg:min-w-[250px]"*/}
      {/*        onClick={() =>*/}
      {/*            isAuth*/}
      {/*                ? viewAllPrizes(TabKey.PREMII_INSTANT)*/}
      {/*                : viewAllPrizes(TabKey.CUM_PARTICIP)*/}
      {/*        }*/}
      {/*    >*/}
      {/*        {isAuth ? "Descoperă premiile" : "Cum particip?"}*/}
      {/*    </button>*/}
      {/*</div>*/}
    </div>
  );
};

export default InstantPrizes;
